import axios from "axios";

import { dataEnv } from "../../config/index.js";
import { verifyRecaptcha } from './recaptcha';

const API_BASE_URL = dataEnv().API_URL;

/* https://api-golden.hexagondata.com/api/v1/auth/signup */

/**
 * Function to know if the user is authenticated
 * @return Boolean
 */
export const isAuthenticated = () => {
  const token = localStorage.getItem("authToken");
  const resp = token ? true : false;
  return resp;
};

/**
 * Function to signup
 * @param {Object} payload
 * @return AxiosPromise
 */
export const signupAccount = (payload) => {
  return axios.post(`${API_BASE_URL}/auth/signup`, payload);
};

/**
 * Function to login
 * @param {Object} payload
 * @return AxiosPromise
 * https://api-golden.hexagondata.com/api/v1/auth/login
 */
export const getLogin = async (loginData) => {
  try {
    // Verificar reCAPTCHA primero
    const recaptchaResponse = await verifyRecaptcha(loginData.recaptchaToken, 'login');
    
    if (!recaptchaResponse.success) {
      throw new Error('La verificación de seguridad falló. Por favor, intente nuevamente.');
    }

    // Si la verificación es exitosa, proceder con el login
    const response = await axios.post(`${API_BASE_URL}/auth/login`, {
      email: loginData.email,
      password: loginData.password
    });
    return response;
  } catch (error) {
    if (error.message.includes('verificación de seguridad')) {
      throw new Error('La verificación de seguridad falló. Por favor, intente nuevamente.');
    }
    throw error;
  }
};

/**
 * Function to get User
 * @param {Object} payload
 * @return AxiosPromise
 * https://api-golden.hexagondata.com/api/v1/auth/me
 */
/* export const getUser= (payload) => {
  return axios.get(`${API_BASE_URL}/auth/me`,payload)
} */
export const getUser = async (authToken) => {
  const response = await axios.get(`${API_BASE_URL}/auth/me`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });

  return response.data;
};

/**
 * Function to set password
 * @param {Object} payload
 * @return AxiosPromise
 */
export const setPassword = (payload) => {
  return axios.post(`${API_BASE_URL}/user/setpassword`, payload);
};

/**
 * Function to recovery password
 * @param {Object} payload
 * @return AxiosPromise
 */
export const recoveryPassword = (email) => {
  return axios.get(`${API_BASE_URL}/user/recoverypwd/${email}`);
};

/**
 * Function to get Dashboard Info
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getInfoDashboard = () => {
  return axios.get(`${API_BASE_URL}/dashboard-info`);
};
